import installChemkitHostBridge from './chemkitBridge/install';

export default installChemkitHostBridge;
